export default {
  invoices: [],
  proFormaInvoices: [],
  cnDns: [],
  payables: [],
  document: null,
  summary: {},
  collection: [],
  consolidated: [],
  selfBilled: [],
  billingdocsCount:[],
  preEinvoiceCreationCount:[],
  orders: [],
  orderSummary: {},
}
